import React from "react";
import ProjectBackgroundImage from "../../assets/EMB.png";
import { useDualTranslation } from "../../utils/i18nHelpers";

const privacyPolicy =
  "https://www.se.com/ww/en/about-us/legal/data-privacy.jsp";

function RegistrationLayout({ children }) {
  const { t } = useDualTranslation();
  const src = "url(" + ProjectBackgroundImage + ")";
  return (
    <se-container position="absolute" direction="column">
      <se-header app-title={t("app.headerTitle")}>
        <se-sidemenu id="app2-sidemenu">
          <se-sidemenu-item item={t("help.title")} aria-label={t("help.title")}></se-sidemenu-item>
          <se-sidemenu-item item={t("menu.about")} aria-label={t("menu.about")}>
            <se-about
              app-title={t("app.headerTitle")}
              version={process.env.REACT_APP_VERSION}
              image-url={src}
            ></se-about>
          </se-sidemenu-item>
          <se-sidemenu-item item={t("menu.legal")} aria-label={t("menu.legal")}>
            <div className="col-md-12">
              <div className="border mt-2 p-2 legal-border">
                <h4>{t("privacy.policyTitle")}</h4>
                <a
                  href={privacyPolicy}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={t("menu.legal")}
                >
                  <h5>{privacyPolicy}</h5>
                </a>
              </div>
            </div>
          </se-sidemenu-item>
          <se-sidemenu-item item={t("menu.userManagement")} aria-label={t("menu.userManagement")}></se-sidemenu-item>
        </se-sidemenu>
      </se-header>
      <se-tabbar color="primary" aria-label="registration-tabbar"></se-tabbar>
      {children}
    </se-container>
  );
}

export default RegistrationLayout;
